import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  InputAdornment,
  makeStyles,
  Paper,
  TextField,
} from "@material-ui/core";
import AppleIcon from "@material-ui/icons/Apple";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import ShopIcon from "@material-ui/icons/Shop";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { compose } from "redux";
import actions from "../../Stores/Auth/actions";
import LogoLight from "../../Components/LogoLight";
import TwoFactorVerification from "./TwoFactorVerification";

const loginAction = actions.login;
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  inputSpacing: {
    marginBottom: "10px",
  },
}));

const Login = ({ login, isLoggingIn, error, isAuthenticated, show2FAScreen, twoFactorEmail, twoFactorRememberMe }) => {
  const classes = useStyles();
  const [show, setShow] = useState(0);
  const [rememberMe, setRememberMe] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const history = useHistory();
  const onChange = (e) =>
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  const onSubmit = (e) => {
    e.preventDefault();
    login({ ...credentials, remember_me: rememberMe }, history);
  };
  
  // Show 2FA screen if required
  if (show2FAScreen && twoFactorEmail) {
    return (
      <TwoFactorVerification 
        email={twoFactorEmail}
        rememberMe={twoFactorRememberMe}
      />
    );
  }

  return (
    <Container maxWidth="xs" style={{ paddingTop: "8rem" }}>
      {isAuthenticated && <Redirect to="/d/company" />}
      {isLoggingIn && (
        <Backdrop className={classes.backdrop} open>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Paper style={{ marginBottom: "20px" }}>
        <Box p="20px">
          <div
            style={{
              width: "40%",
              marginLeft: `-1.2rem`,
              marginTop: `-0.5rem`,
              marginBottom: "0.6rem",
            }}
          >
            <LogoLight />
          </div>
          <div>
            <form onSubmit={onSubmit}>
              <TextField
                name="email"
                label="Email"
                type="email"
                fullWidth
                autoFocus
                required
                value={credentials.email}
                onChange={onChange}
                className={classes.inputSpacing}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <PersonOutlineOutlinedIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                name="password"
                label="Password"
                // type="password"
                type={show ? "text" : "password"}
                fullWidth
                required
                value={credentials.password}
                onChange={onChange}
                className={classes.inputSpacing}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      {show ? (
                        <VisibilityIcon onClick={() => setShow(false)} />
                      ) : (
                        <VisibilityOffIcon onClick={() => setShow(true)} />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <Grid container alignItems="center" justify="space-between">
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox 
                        color="primary" 
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                    }
                    label="Remember me for 30 days"
                  />
                </Grid>
                <Grid item>
                  <Button
                    disableFocusRipple
                    disableRipple
                    style={{ textTransform: "none" }}
                    variant="text"
                    color="primary"
                    type="button"
                  >
                    <Link to="/forgot/password">Forgot password?</Link>
                  </Button>
                </Grid>
              </Grid>
              {/* {error != null && error.message ? (
                <Grid container justify="flex-start">
                  <Alert severity="error">{error.message}!</Alert>
                </Grid>
              ) : (
                ''
              )} */}
              <Grid container justify="flex-end" style={{ marginTop: "10px" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ textTransform: "none" }}
                >
                  Login
                </Button>
              </Grid>
            </form>
          </div>
        </Box>
      </Paper>
    </Container>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isLoggingIn: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = ({ AuthReducer }) => ({
  isAuthenticated: AuthReducer.isAuthenticated,
  isLoggingIn: AuthReducer.isLoggingIn,
  error: AuthReducer.error,
  show2FAScreen: AuthReducer.show2FAScreen,
  twoFactorEmail: AuthReducer.twoFactorEmail,
  twoFactorRememberMe: AuthReducer.twoFactorRememberMe,
});
function mapDispatchToProps(dispatch) {
  return {
    login: (...args) => dispatch(loginAction(...args)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Login);
